import { Routes } from '@angular/router';
import { loginGuard } from '@kimbocare/auth';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
    canActivate: [loginGuard()],
  },
  {
    path: 'send-health-bundle',
    loadChildren: () =>
      import('./features/send-health-bundle/send-health-bundle.module').then(
        (m) => m.SendHealthBundleModule,
      ),
    canActivate: [loginGuard()],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./authentication/login/login.module').then(
        (m) => m.LoginModule,
      ),
    canActivate: [guestGuard()],
  },
];
